import { render } from "./FleetCard.vue?vue&type=template&id=04315c1f"
import script from "./FleetCard.vue?vue&type=script&lang=js"
export * from "./FleetCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__